import type { ErrorMap } from '@/app/error-registry';

export const BOARDS_ERROR_MAP: ErrorMap = {
  POST: {
    'Board.NameAlreadyExists': 'boards:apiErrors.nameAlreadyExists',
    default: 'boards:apiErrors.createDefault',
  },
  PUT: {
    'Board.NotFound': 'boards:apiErrors.notFound',
    'Board.Forbidden': 'boards:apiErrors.forbidden',
    default: 'boards:apiErrors.updateDefault',
  },
  DELETE: {
    'Board.NotFound': 'boards:apiErrors.notFound',
    'Board.Forbidden': 'boards:apiErrors.forbidden',
    default: 'boards:apiErrors.deleteDefault',
  },
  PATCH: {
    'Board.NotFound': 'boards:apiErrors.notFound',
    default: 'boards:apiErrors.reorderDefault',
  },
};

export const BOARD_STATUSES_ERROR_MAP: ErrorMap = {
  POST: {
    'BoardStatus.NameAlreadyExists': 'boards:apiErrors.statusNameAlreadyExists',
    default: 'boards:apiErrors.statusCreateDefault',
  },
  PUT: {
    'BoardStatus.NotFound': 'boards:apiErrors.statusNotFound',
    'BoardStatus.Forbidden': 'boards:apiErrors.statusForbidden',
    default: 'boards:apiErrors.statusUpdateDefault',
  },
  DELETE: {
    'BoardStatus.NotFound': 'boards:apiErrors.statusNotFound',
    default: 'boards:apiErrors.statusDeleteDefault',
  },
  PATCH: {
    'BoardStatus.NotFound': 'boards:apiErrors.statusNotFound',
    default: 'boards:apiErrors.statusReorderDefault',
  },
};

export const BOARD_VIEWS_ERROR_MAP: ErrorMap = {
  POST: {
    'BoardView.AlreadyExists': 'boards:apiErrors.viewAlreadyExists',
    'BoardView.InvalidType': 'boards:apiErrors.viewInvalidType',
    default: 'boards:apiErrors.viewCreateDefault',
  },
  DELETE: {
    'BoardView.NotFound': 'boards:apiErrors.viewNotFound',
    default: 'boards:apiErrors.viewDeleteDefault',
  },
};

export const BOARD_GROUPS_ERROR_MAP: ErrorMap = {
  POST: {
    'TaskGroup.NameAlreadyExists': 'boards:apiErrors.groupCreateDuplicate',
    default: 'boards:apiErrors.groupCreateDefault',
  },
  PUT: {
    'TaskGroup.NotFound': 'boards:apiErrors.groupNotFound',
    'TaskGroup.Forbidden': 'boards:apiErrors.groupForbidden',
    default: 'boards:apiErrors.groupUpdateDefault',
  },
  DELETE: {
    'TaskGroup.NotFound': 'boards:apiErrors.groupNotFound',
    default: 'boards:apiErrors.groupDeleteDefault',
  },
  PATCH: {
    'TaskGroup.NotFound': 'boards:apiErrors.groupNotFound',
    default: 'boards:apiErrors.groupReorderDefault',
  },
};
